import React, { useState, useEffect } from 'react';
import InputCustom from '../../../../Components/InputCustom';
import {Listbox, ListboxItem} from '../../../../Components/Listbox/Listbox';

export const CategorySelector = ({
	categoryList,
	handleSelectCategory
}) => {

	const [inputSearch, setinputSearch] = useState('');
	const [finalOptionsList, setFinalOptionsList] = useState<any>([]);
	const [searchResult, setsearchResult] = useState<any>('');
	const [valuesForSelect, setValuesForSelect] = useState<any>([]);

	useEffect(() => {
		if (categoryList && categoryList.length > 0) {
			const tmpList = categoryList.map(i => {
				return { value: i.name, label: i.label };
			});
			setValuesForSelect(tmpList);
			setsearchResult(tmpList);
		}
	}, [categoryList]);

	const search = (table, word) => {
		if (word.length > 0) {
			setsearchResult([]);
			const resultName = table.filter(line => line.toUpperCase().match(`.*${word.toUpperCase()}.*`));
			const res = resultName.map(i => {
				return { value: i, label: i };
			});
			setsearchResult(res);
		} else {
			setsearchResult(valuesForSelect);
		}
	};

	const handleChangeSearch = (event) => {
		setinputSearch(event);
		search(valuesForSelect.map(v => v.value), event);
	};

	useEffect(() => {
		setFinalOptionsList([
			{
				id: 'group1',
				items: searchResult
			}
		]);
	}, [searchResult]);

	return (
		<>
			<div className='listbox_input_section flex_item_fix'>
				<InputCustom
					value={inputSearch}
					placeholder={'Search for a category'}
					autoFocus={true}
					fullWidth={true}
					forceFocus={true}
					onChange={(e) => handleChangeSearch(e.target.value)}
					clearable={true}
				/>
			</div>
			<div className='flex_item_auto vscroll_custom'>
				{finalOptionsList && finalOptionsList.map((list) => (
					<Listbox
						direction={'column'}
						key={list.id}
						groupLabel={ null}>
						{list.items && list.items.map((o, i) => (
							<ListboxItem
								key={list.id + '_' + i}
								message={o.children ? null : o.label}
								description={o.children ? null : o.description}
								imageUrl={o.children ? null : o.image}
								onClick={() => handleSelectCategory(o.label)}
							>
								{o.children}
							</ListboxItem>
						))}
					</Listbox>
				))}

				{inputSearch
					&& (!searchResult || searchResult?.length === 0) &&
					<Listbox>
						<ListboxItem
							message={'No option'}
							disabled={true}
						/>
					</Listbox>
				}
			</div>
		</>
	);
};
